import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

// const Wrapper = styled.div`
//   text-align: right;
//   font-size: 1.2rem;
//   padding-top: 2px;
// `;

function Parents(props) {
  const { parents, className } = props;
  return <div className={className}>{parents.filter(Boolean).map((p) => p.displayName).join(', ')}</div>;
}

Parents.propTypes = {
  parents: PropTypes.array,
  className: PropTypes.string,
};

export default Parents;
